import { fetchSettings } from 'Helpers/utils';

const globSettings = fetchSettings() || {};

export const {
  APPOINTMENT_X_API_KEY,
  FILE_API_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_API_KEY,
  FIREBASE_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_VAPID,
} = globSettings;
